import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Lot extends ApplicationRecord {
  static jsonapiType = 'lots';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Type',
        value: 'lotType',
      },
      {
        text: 'Spaces',
        value: 'spaces',
      },
    ];
  }

  static scopeFactory() {
    return Lot.includes([]);
  }

  @Attr() name: string;
  @Attr() slug: string;
  @Attr() productCodename: string;
  @Attr() lotType: string;
  @Attr() spaces: number;
  @Attr() fillRateThreshold: string;
  @Attr() subscriptionParkingDiscount: boolean;

  get formattedType() {
    if (!this.lotType) {
      return;
    }

    return this.lotType.charAt(0).toUpperCase() + this.lotType.slice(1);
  }
}
